import { useEffect, useState } from "react"
import { useAppContext } from "../../../hooks/appContext"
import type { ConversationListData, DMUnreadData } from "../types"

type Props = {
    dmUnreadData: DMUnreadData
    conversationListData: ConversationListData
}
type UseUnreadCount = (props: Props) => { unreadCount: number }

/**
 * Custom hook to subscribe to DM unread count updates.
 * @param dmUnreadData - instance providing unread data events
 * @returns An object containing the current unread count.
 */
export const useUnreadCount: UseUnreadCount = ({
    dmUnreadData,
    conversationListData,
}) => {
    const [unreadCount, setUnreadCount] = useState<number>(0)

    const {
        context: { logged_in_user },
    } = useAppContext()

    const isAnonymous = !logged_in_user?.username

    useEffect(() => {
        if (isAnonymous) {
            return
        }

        dmUnreadData.getInstance()
        conversationListData.getInstance()

        const handleUpdate = ({ unread }: { unread: number }) => {
            setUnreadCount(unread)
        }
        dmUnreadData.unreadDataUpdated.listen(handleUpdate)

        return () => {
            dmUnreadData.unreadDataUpdated.removeListener(handleUpdate)
        }
    }, [dmUnreadData, isAnonymous])

    return { unreadCount }
}
